module.exports = __webpack_public_path__ + "c843a27f86f344e771b6b422af984cdd.png";